import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { finalBenefits } from '../data/copy';
export function FinalCtaSection() {
  return <section className="w-full bg-cream py-10 sm:py-12" aria-labelledby="final-cta-heading" data-id="element-48" data-mp="3qt9mp4w6lwu3">
      <div className="mx-auto max-w-5xl px-6" data-id="element-49" data-mp="3vt5r358sjqa6">
        <div className="text-center" data-id="element-50" data-mp="3vrumj37iuei0">
          <Pill tone="rose" data-id="element-51" data-mp="2y542qkcycbvb">Your next teaching week</Pill>
          <h2 id="final-cta-heading" className="mx-auto mt-5 max-w-3xl font-display text-4xl leading-tight text-charcoal sm:text-5xl" data-id="element-52" data-mp="2y6ouy3bsniq0">
            Next Monday you can keep building your ballet classes from scratch…
          </h2>
          <p className="mx-auto mt-4 max-w-2xl font-display text-2xl italic leading-snug text-wine" data-id="element-53" data-mp="3ctruefjog1fz">
            Or you can walk into the studio with everything ready—from today.
          </p>
        </div>

        <ul className="mx-auto mt-9 grid max-w-4xl gap-3 sm:grid-cols-2" data-id="element-54" data-mp="2kd7ewsibgo4q">
          {finalBenefits.map(benefit => <li key={benefit} className="flex items-start gap-3 rounded-2xl border border-rose-deep/20 bg-blush px-5 py-4" data-id="element-55" data-mp="2dcjkbhnsul1r">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-rose-light" aria-hidden="true" data-id="element-56" data-mp="28dyjph4mxzcs">
                <CheckIcon className="h-3 w-3 text-wine" strokeWidth={2.4} data-id="element-57" data-mp="23k40sfwutoer" />
              </span>
              <span className="font-sans text-[0.9rem] leading-relaxed text-charcoal/85" data-id="element-58" data-mp="1yl18zx5vxeoq">
                {benefit}
              </span>
            </li>)}
        </ul>

        <div className="mt-10 rounded-4xl border border-gold/35 bg-blush px-7 py-11 text-center sm:px-12" data-id="element-59" data-mp="1ple8reow6ex9">
          <p className="mx-auto max-w-2xl font-display text-3xl leading-snug text-charcoal" data-id="element-60" data-mp="1ko4ad9jiysxa">
            Ballet Teacher Elite System doesn’t make you a better teacher.
            <span className="mt-3 block text-wine" data-id="element-61" data-mp="3f1vmqgt8nqwf">
              You are already a great teacher.
            </span>
          </p>
          <p className="mx-auto mt-5 max-w-readable font-sans text-base leading-relaxed text-ash" data-id="element-62" data-mp="3a2sj90swpsqk">
            What it does is give you the time and tools to make that visible in
            every single class you teach.
          </p>
          <CtaButton size="large" className="mt-8" data-id="element-63" data-mp="1d5mwkr4m8ryi">
            Get the complete system for $27
          </CtaButton>
        </div>
      </div>
    </section>;
}